<template>
  <div class="add-funds-combined">
    <deposit-promotions-banner
      class="add-funds-combined__promotions-banner"
      :items="notifications"
    ></deposit-promotions-banner>
    <fee-waived-banner
      v-if="feeWaivedBannerTxt && false"
      class="add-funds-combined__fee-waived-banner"
      :text="feeWaivedBannerTxt"
    ></fee-waived-banner>
    <div
      v-if="showTabs && !hideTabs"
      class="add-funds-combined__tabs"
      :class="{ 'add-funds-combined__tabs--no-top-margin': notifications.length }"
    >
      <deposit-tabs :items="tabs" theme="wallet" @tabChange="tabChange"> </deposit-tabs>
    </div>
    <div
      class="add-funds-combined__content add-funds-combined__content--loading"
      v-if="!showTabs"
    ></div>
    <div class="add-funds-combined__content" v-else>
      <add-funds-bank-transfer
        v-if="showBankingTab"
        @step="onBankTransferStep"
        @notification="onChildNotification"
        :instantCreditData="instantCreditData"
        :isPopup="true"
      ></add-funds-bank-transfer>
      <add-funds-credit-card
        v-if="showCardTab"
        :instantCreditData="instantCreditData"
        @notification="onChildNotification"
      ></add-funds-credit-card>
      <add-funds-transfers
        v-if="showTransfersTab"
        :instantCreditData="instantCreditData"
        @notification="onChildNotification"
      ></add-funds-transfers>
      <add-funds-cash
        v-if="showCashTab"
        :instantCreditData="instantCreditData"
        @notification="onChildNotification"
      ></add-funds-cash>
      <add-funds-coinbase
        v-if="showCoinBaseTab"
        :instantCreditData="instantCreditData"
        @notification="onChildNotification"
      ></add-funds-coinbase>
    </div>
  </div>
</template>

<script src="./add-funds-combined.js"></script>
<style src="./add-funds-combined.scss" lang="scss"></style>
